import { __require as q } from "./_ListCache.js";
import { __require as k } from "./_stackClear.js";
import { __require as m } from "./_stackDelete.js";
import { __require as f } from "./_stackGet.js";
import { __require as n } from "./_stackHas.js";
import { __require as h } from "./_stackSet.js";
var r, t;
function z() {
  if (t) return r;
  t = 1;
  var a = q(), i = k(), s = m(), _ = f(), o = n(), c = h();
  function e(u) {
    var p = this.__data__ = new a(u);
    this.size = p.size;
  }
  return e.prototype.clear = i, e.prototype.delete = s, e.prototype.get = _, e.prototype.has = o, e.prototype.set = c, r = e, r;
}
export {
  z as __require
};
